import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { AfterViewInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class IndexComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('slideGuiasWeb', { static: false }) slideGuiasWeb!: ElementRef;

  private observer!: IntersectionObserver;
  private isS2Visible = false;
  private isS3Visible = false;
  private isS4Visible = false;
  private isS5Visible = false;

  // Flag: si es true, NO se vuelve a abrir hasta recargar la página
  private hasClosedGuias = false;
  private hasClosedGuiasMovil = false;
  private isShownDesktop = false;
  private isShownMovil = false;

  constructor(private router: Router, private scroller: ViewportScroller) { }

  ngOnInit() {
    // setTimeout(this.showPromo, 2000);
    // setTimeout(this.showslide, 2000);
    // setTimeout(this.shownewslide, 2000);

    // if (window.innerWidth <= 1027) {
    //     setTimeout(this.shownewslidemovilscreen, 2000);
    //     }

    // if (window.innerWidth >= 1027) {
    //     setTimeout(this.shownewslide, 2000);
    // }

  }
  ngAfterViewInit(): void {
    const s2 = document.getElementById('section2');
    const s3 = document.getElementById('section3');
    const s4 = document.getElementById('section4');
    const s5 = document.getElementById('precios-home');

    if (!s2 || !s3 || !s4 || !s5) return;

    // Empieza oculto
    this.hideDesktop();
    this.hideMovil();

    // Comprobación inicial (por si cargas en section1)
    this.isS2Visible = this.checkVisible(s2, 0.4);
    this.isS3Visible = this.checkVisible(s3, 0.4);
    this.isS4Visible = this.checkVisible(s4, 0.4);
    this.isS5Visible = this.checkVisible(s5, 0.4);
    this.applyVisibility(); // decide mostrar/ocultar en base a S2/S3/S4/S5

    // Observer SOLO para S2/S3/S4
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.target.id === 'section2') this.isS2Visible = entry.isIntersecting;
          if (entry.target.id === 'section3') this.isS3Visible = entry.isIntersecting;
          if (entry.target.id === 'section4') this.isS4Visible = entry.isIntersecting;
          if (entry.target.id === 'precios-home') this.isS5Visible = entry.isIntersecting;
        }
        this.applyVisibility();
      },
      { root: null, threshold: 0.4 }
    );

    this.observer.observe(s2);
    this.observer.observe(s3);
    this.observer.observe(s4);
    this.observer.observe(s5);

    // Observer para la animación de elementos internos de teaser-guias
    const teaserGuias = document.querySelector('.teaser-guias');
    if (teaserGuias) {
      const observerTeaser = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Seleccionamos los elementos internos a animar
            const badge = teaserGuias.querySelector('.new-badge');
            const title = teaserGuias.querySelector('h2');
            const paragraph = teaserGuias.querySelector('p');
            const button = teaserGuias.querySelector('.btn-teaser');

            // Agregamos la clase de animación si existen
            if (badge) badge.classList.add('animacion_items');
            if (title) title.classList.add('animacion_items');
            if (paragraph) paragraph.classList.add('animacion_items');
            if (button) button.classList.add('animacion_items');

            // Opcional: Dejar de observar una vez animado
            observerTeaser.unobserve(teaserGuias);
          }
        });
      }, { threshold: 0.3 });

      observerTeaser.observe(teaserGuias);
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }



  section1() {
    document.getElementById("section1").scrollIntoView({ behavior: "smooth" });
  }
  section2() {
    document.getElementById("section2").scrollIntoView({ behavior: "smooth" });
  }
  section3() {
    document.getElementById("section3").scrollIntoView({ behavior: "smooth" });
  }
  section4() {
    document.getElementById("section4").scrollIntoView({ behavior: "smooth" });
  }

  // ---------- Core visibility control ----------
  private applyVisibility() {
    const allowedVisible = this.isS2Visible || this.isS3Visible || this.isS4Visible || this.isS5Visible;

    // Desktop
    if (!this.hasClosedGuias) {
      if (allowedVisible && !this.isShownDesktop && window.innerWidth > 1027) {
        setTimeout(() => this.showDesktop(), 200); // pequeño delay opcional
      } else if ((!allowedVisible || window.innerWidth <= 1027) && this.isShownDesktop) {
        this.hideDesktop();
      }
    } else {
      this.hideDesktop();
    }

    // Móvil
    if (!this.hasClosedGuiasMovil) {
      if (allowedVisible && !this.isShownMovil && window.innerWidth <= 1027) {
        setTimeout(() => this.showMovil(), 200);
      } else if ((!allowedVisible || window.innerWidth > 1027) && this.isShownMovil) {
        this.hideMovil();
      }
    } else {
      this.hideMovil();
    }
  }

  private showDesktop() {
    if (this.hasClosedGuias) return;
    const el = document.getElementById("slide_guiasweb");
    if (!el) return;
    el.style.visibility = "visible";
    el.style.transform = 'translateX(0)';
    el.style.display = 'block';
    this.isShownDesktop = true;
  }
  private hideDesktop() {
    const el = document.getElementById("slide_guiasweb");
    if (!el) return;
    el.style.display = 'none';
    this.isShownDesktop = false;
  }


  private showMovil() {
    if (this.hasClosedGuiasMovil) return;
    const el = document.getElementById("popop_guiasweb_movil");
    if (!el) return;
    el.style.visibility = "visible";
    el.style.height = "118px";
    el.style.top = "10px";
    el.style.display = 'block';
    this.isShownMovil = true;
  }
  private hideMovil() {
    const el = document.getElementById("popop_guiasweb_movil");
    if (!el) return;
    el.style.display = 'none';
    this.isShownMovil = false;
  }

  private checkVisible(el: Element, threshold = 0.4): boolean {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const visiblePx = Math.min(vh, r.bottom) - Math.max(0, r.top);
    const elemHeight = Math.max(1, r.height);
    const visibleRatio = Math.max(0, Math.min(visiblePx / elemHeight, 1));
    return visibleRatio >= threshold;
  }

  // ---------- Botones cerrar ----------
  closeBtnGuiaslide() {
    this.hasClosedGuias = true;
    this.hideDesktop();
  }
  closeBtnpopupguiasmovil(event: Event) {
    this.hasClosedGuiasMovil = true;
    this.hideMovil();
    event.stopPropagation();
  }

  // closeBtn() {
  //   document.getElementById("cont_promo").style.display = "none";
  // }
  // closeBtnslide() {
  //   document.getElementById("cont_slide").style.display = "none";
  // }


}
